import { render, staticRenderFns } from "./NewPassword.vue?vue&type=template&id=c6d64e1a&"
import script from "./NewPassword.vue?vue&type=script&lang=ts&"
export * from "./NewPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports